import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { PROJECT_TRASH_PREFIX_URL } from './constants/config.trash'

const LayoutTrash = lazy(() => import('./Layout.Trash'))

const ProjectTrashRouters: AppRouterItem[] = [
  {
    path: `${PROJECT_TRASH_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <LayoutTrash />
      </LoadingLazyComponents>
    ),
  },
]

export default ProjectTrashRouters
